var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClubsLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 11,
    fill: "#12101A",
    stroke: "#A046D3",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6199_60325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.656 22.0371C26.7313 22.0371 25.9356 22.5709 25.5485 23.3609C25.2474 23.7025 24.7958 23.852 24.3227 23.9588C24.4302 23.4036 24.5593 22.7844 24.9894 22.4214C25.7851 22.0371 26.3227 21.247 26.3227 20.3289C26.3227 19.0477 25.2689 18.0015 23.9786 18.0015C22.7098 18.0015 21.656 19.0477 21.656 20.3289C21.656 21.247 22.1937 22.0371 22.9894 22.4214C23.3765 22.699 23.5485 23.3822 23.656 23.9588C23.2044 23.852 22.7313 23.7025 22.4517 23.3609C22.0646 22.5709 21.2689 22.0371 20.3442 22.0371C19.0539 22.0371 18.0001 23.062 18.0001 24.3431C18.0001 25.6242 19.0539 26.6705 20.3442 26.6705C21.2689 26.6705 22.1507 26.0513 22.5378 25.2612C22.8603 24.8983 23.2689 24.8129 23.7636 24.7274C23.8066 25.3894 23.7851 26.094 23.6775 26.4997C23.2044 27.8449 22.0216 29.4463 21.3765 30.0015C22.2367 29.2541 25.7636 29.2541 26.6238 30.0015C25.9786 29.4463 24.7098 27.7595 24.3227 26.4997C24.1937 25.9872 24.2152 25.0477 24.2152 24.7061C24.7098 24.7915 25.1184 24.8769 25.4625 25.2399C25.8496 26.0086 26.7313 26.6491 27.656 26.6491C28.9464 26.6491 30.0001 25.6029 30.0001 24.3217C29.9786 23.062 28.9464 22.0371 27.656 22.0371Z",
    fill: "#A046D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6199_60325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(17.1431 17.1445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubsLoader);
export default __webpack_public_path__ + "static/media/clubs-loader.c9b3d00d9a2ff30374d9d7268aeb8ec0.svg";
export { ForwardRef as ReactComponent };